var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2425_8415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1582 0H22.3859C22.5685 2.25671 21.7072 3.94291 20.6603 5.16401C19.6331 6.37667 18.2266 7.5528 15.9516 7.37435C15.7998 5.14996 16.6626 3.58881 17.708 2.37053C18.6776 1.23515 20.4552 0.224828 22.1582 0ZM29.045 23.4889V23.5521C28.4056 25.4884 27.4937 27.1479 26.3808 28.688C25.3648 30.0862 24.1199 31.9677 21.8969 31.9677C19.976 31.9677 18.7001 30.7325 16.7315 30.6988C14.649 30.6651 13.5038 31.7316 11.5998 32H10.9506C9.55242 31.7977 8.42407 30.6904 7.60204 29.6927C5.17812 26.7447 3.30503 22.9366 2.95654 18.0635V16.6316C3.10409 13.144 4.79872 10.3083 7.05122 8.93409C8.23999 8.2034 9.87421 7.58091 11.6939 7.85913C12.4738 7.97998 13.2705 8.24696 13.9689 8.51113C14.6307 8.76547 15.4584 9.21653 16.2425 9.19264C16.7736 9.17718 17.302 8.90036 17.8373 8.70504C19.4055 8.13876 20.9428 7.48957 22.969 7.79449C25.4042 8.16265 27.1325 9.24463 28.2005 10.914C26.1405 12.225 24.5119 14.2007 24.7901 17.5745C25.0374 20.6392 26.8192 22.4322 29.045 23.4889Z",
    fill: "#1B1B1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2425_8415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.22cdc4b178d4812e990ae687307e2c08.svg";
export { ForwardRef as ReactComponent };